/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreMenuService {
  public onItemCollapsed: Subject<any>;
  public onItemCollapseToggled: Subject<void>;

  private _onMenuRegistered: BehaviorSubject<any>;
  private _onMenuUnregistered: BehaviorSubject<any>;
  private _onMenuChanged: BehaviorSubject<any>;
  private _currentMenuKey: string | null;
  private _registry: { [key: string]: any } = {};

  constructor(
    private _router: Router,
  ) {
    this.onItemCollapsed = new Subject();
    this.onItemCollapseToggled = new Subject<void>();

    this._currentMenuKey = null;
    this._onMenuRegistered = new BehaviorSubject(null);
    this._onMenuUnregistered = new BehaviorSubject(null);
    this._onMenuChanged = new BehaviorSubject(null);
  }

  public get onMenuRegistered(): Observable<any> {
    return this._onMenuRegistered.asObservable();
  }

  public get onMenuUnregistered(): Observable<any> {
    return this._onMenuUnregistered.asObservable();
  }

  public get onMenuChanged(): Observable<any> {
    return this._onMenuChanged.asObservable();
  }

  public register(key: string | number, menu: any): void {
    if (this._registry[key]) {
      console.error(
        `Menu with the key '${key}' already exists. Either unregister it first or use a unique key.`
      );

      return;
    }

    this._registry[key] = menu;

    this._onMenuRegistered.next([key, menu]);
  }

  public unregister(key: string | number): void {
    if (!this._registry[key]) {
      console.warn(`Menu with the key '${key}' doesn't exist in the registry.`);
    }

    delete this._registry[key];

    this._onMenuUnregistered.next(key);
  }

  public getKeys(): string[] | undefined {
    if (!Object.keys(this._registry)) {
      console.warn(`Key doesn't exist in the registry.`);

      return;
    }

    return Object.keys(this._registry);
  }

  public getMenu(key: string): any {
    if (!this._registry[key]) {
      console.warn(`Menu with the key '${key}' doesn't exist in the registry.`);

      return;
    }

    return this._registry[key];
  }

  public getCurrentMenu(): any {
    if (!this._currentMenuKey) {
      console.warn(`The current menu is not set.`);

      return;
    }

    return this.getMenu(this._currentMenuKey);
  }

  public setCurrentMenu(key: string): void {
    if (!this._registry[key]) {
      console.warn(`Menu with the key '${key}' doesn't exist in the registry.`);

      return;
    }

    this._currentMenuKey = key;

    this._onMenuChanged.next(key);
  }
}
